import Ideal from "./Ideal";
import style from "../style/layout.module.css";
import Share from "./Share";

export default function Result({ children }) {
  return (
    <div className={style.result}>
      <h3 className={style.result_text}>최종 우승자</h3>
      {children}
      <Ideal />
      <Share />
    </div>
  );
}
